import sendEventToPiano from './send_event_to_piano';

export default class AtInternetManager {
  static sendCreateRequestEvent() {
    sendEventToPiano('click.action', { 'click': 'click creation_demande' });
  }

  static sendSeeMyRequestsEvent() {
    sendEventToPiano('click.action', { 'click': 'click mes_demandes' });
  }

  static sendSeeAllMyRequestsEvent() {
    sendEventToPiano('click.action', { 'click': 'click toutes_demandes' });
  }

  static sendExportMyRequestsEvent() {
    sendEventToPiano('click.action', { 'click': 'click export_demandes' });
  }

  static sendShareEmailEvent() {
    sendEventToPiano('click.action', { 'click': 'click partager_mail' });
  }

  static sendValidateDeleteRequestEvent() {
    sendEventToPiano('click.action', { 'click': 'click validation_suppression_demande' });
  }

  static sendFastModeRequestEvent() {
    sendEventToPiano('click.action', { 'click': 'click mode_rapide_demande' });
  }

  static sendChoiceModeRequestEvent() {
    sendEventToPiano('click.action', { 'click': 'click mode_choix_demande' });
  }

  static sendInternalDepartementOpeningEvent() {
    sendEventToPiano('click.action', { 'click': 'click ouverture_interne_service' });
  }

  static sendInternalDepartementOpeningValidateEvent() {
    sendEventToPiano('click.action', { 'click': 'click ouverture_interne_valide' });
  }

  static sendExternalOpeningEvent() {
    sendEventToPiano('click.action', { 'click': 'click ouverture_externe' });
  }

  static sendOpeningForAllEvent() {
    sendEventToPiano('click.action', { 'click': 'click ouverture_tous' });
  }

  static sendNumberCopyPersonEvent() {
    sendEventToPiano('click.action', { 'click': 'click personne_copie' });
  }

  static sendReasonForReplacementEvent() {
    sendEventToPiano('click.action', { 'click': 'click motif_remplacement' });
  }

  static sendNumberRequestsMadeEvent() {
    sendEventToPiano('click.action', { 'click': 'click validation_demande' });
  }

  static sendNumberApplicantsRefusedtEvent() {
    sendEventToPiano('click.action', { 'click': 'click refuser_candidat_demande' });
  }
}





// WEBPACK FOOTER //
// ./src/helpers/at_internet/manage_requests.js